import { Component, OnInit } from '@angular/core';
import { ApiService } from '../../../shared/api-service/api.service';
import { AuthService } from '../../../shared/auth/auth.service';
import { Router } from '@angular/router';
import { HelpersService } from '../../../shared/helpers/helpers.service';
import { SearchService } from '../../../shared/search/search.service';
import { Subject } from 'rxjs/Subject';
import { Logging } from '../../../logging';
import { ComponentID, ActionType, PermissionHelper } from '../../../shared/helpers/permissionshelper';

@Component({
  selector: 'app-subusers-list',
  templateUrl: './subusers-list.component.html',
  styleUrls: ['./subusers-list.component.css']
})
export class SubusersListComponent implements OnInit {

  constructor(private api: ApiService,
    private auth: AuthService,
    private router: Router,
    private helpers: HelpersService,
    private searchService: SearchService,private componentid : ComponentID ,
    private actiontype: ActionType,private permhelper:PermissionHelper) { }

    users: string[] = [];
    currPage: number = 1;
    totalItems: number;
    itemsPerPage: number;
    loading: boolean;
    search_term: any = '';
    searchTerm$ = new Subject<string>();

    
 
    ngOnInit() {
      this.getData(0);

      this.searchService.search(this.searchTerm$)
      .subscribe(results => {
         Logging.log('search triggered');
        this.search_term = results;
        this.getData(0)
      });

    }

    Helpers(){
      return this.helpers;
    }
  
    UserID()
    {
        return this.auth.getUserID();
    }
    
  
    getData(page:number){
  
      this.loading = true;
      window.scrollTo(0, 0);
      //Fetch all users
      this.api.get('/users/'+ this.auth.getUserID() + '/subusers' + '?sort=createdtime,desc&search='+this.search_term+'&page=' + page)
      .subscribe(
        res_data => {
        Logging.log(res_data.data);
        this.users = res_data.data.content;
        this.totalItems = res_data.data.totalElements;
        this.itemsPerPage = res_data.data.size;
        this.currPage = res_data.data.number;
        this.loading = false;
        
        }, error_message => {
          this.loading = false;
         //  this.hasError = true;
         //  this.errorMessage = error_message;
        }
      );
    }

}



// WEBPACK FOOTER //
// ./src/app/client/account/subusers-list/subusers-list.component.ts